import React from 'react';
import { useSelector } from 'react-redux';
import acessos from '~/pages/Sistema/acessos';
import { tipoAcesso } from '~/config/definicoesPadrao';
import { Colors } from '~/config/Colors';

import { ItemMenu, ItemButtonMenu, NotificationDot } from './styles';

function MenuButton({
  desktop,
  menu,
  selected,
  showSubMenu,
  setShowSubMenu,
  showMenuWithSubMenu,
  setShowMenuWithSubMenu,
  setComponentPath,
  currentModulo,
  hasUnreadComunicados,
}) {
  const {
    auth: { perfil },
  } = useSelector(state => state) || {};

  // Mostrar indicador apenas no menu Home quando há comunicados não lidos
  const showNotificationDot = menu?.path === 'Home' && hasUnreadComunicados;

  return (
    <ItemMenu desktop={desktop} selected={selected}>
      <div className="content-item-menu">
        <ItemButtonMenu
          desktop={desktop}
          selected={selected}
          bgColor={Colors?.Color1}
          bgColorSelect={Colors?.Color8}
          ftColor={Colors?.Color7}
          ftColorSelect={Colors?.Color4}
          onClick={() => {
            if (menu?.possuiSubMenu) {
              if (showMenuWithSubMenu?.id != menu?.id) {
                setShowMenuWithSubMenu(menu);
                setShowSubMenu(true);
              } else if (showMenuWithSubMenu) {
                setShowMenuWithSubMenu(undefined);
                setShowSubMenu(!showSubMenu);
              } else {
                setShowMenuWithSubMenu(menu);
                setShowSubMenu(!showSubMenu);
              }
            } else {
              const Componente =
                acessos?.[tipoAcesso[perfil?.tipo]]?.[currentModulo?.path]?.[menu?.path];

              if (typeof Componente === 'function') {
                setComponentPath({
                  moduloPath: currentModulo?.path,
                  menuPath: menu?.path,
                  subMenuPath: undefined,
                });

                setShowMenuWithSubMenu(undefined);
                setShowSubMenu(false);
              }
            }
          }}
        >
          {showNotificationDot && <NotificationDot />}
          <div className="bgColor">
            <img
              src={require('~/assets/menus/' +
                (selected ? 'ativo/' : 'desativo/') +
                menu.icone +
                '.svg')}
              alt={menu.nome}
            />
          </div>
          <p>{menu.nome}</p>
        </ItemButtonMenu>
      </div>
    </ItemMenu>
  );
}

export default MenuButton;
